export enum ATTACHMENT_TYPES {
  PICTURE = 'PICTURE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT'
}
